import { render, staticRenderFns } from "./navMenuItem.vue?vue&type=template&id=52ef59e9&scoped=true&"
import script from "./navMenuItem.vue?vue&type=script&lang=js&"
export * from "./navMenuItem.vue?vue&type=script&lang=js&"
import style0 from "./navMenuItem.vue?vue&type=style&index=0&id=52ef59e9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.7.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52ef59e9",
  null
  
)

export default component.exports